const supervise = {
  superviseOrg: '监管机构',
  group: '分组',
  correctTime: '入矫时间',
  correctPlan: '矫正计划',
  isBindDevice: '是否戴表',
  absent: '请假',
  Male: '性别',
  male: '男',
  female: '女',
  name: '姓名',
  identityID: '身份证号',
  birthday: '出生日期',
  phone: '电话',
  address: '住址',
  fenceType: '围栏类型',
  defaultGroup: '默认分组',
  groupName: '分组名称',
  groupDescription: '分组描述',
  applyChild: '应用到子机构',
  applyChildTip: '设置为应用到子机构后当前修改对所有子机构生效',
  editSuperviseRule: '修改监管规则',
  groupAliasName: '分组别名',
  groupNameRequired: '分组名称是必须的',
  nameRule: '长度应在30字内',
  aliasNameRequired: '请输入分组别名',
  descriptionRequired: '请输入分组描述',
  descriptionRule: '分组描述应在200字内',
  option: '基本配置',
  locateFreq: '定位频率',
  locateFreqBase: 'WIFI/基站定位频率',
  locateFreqBle: '蓝牙定位频率',
  locateFreqGps: '卫星定位频率',
  autoAdjust: '自动降频',
  autoPowerUp: '自动开机',
  autoPowerDown: '自动关机',
  customLocate: '分段设置',
  modelLocate: '分类设置',
  segmentTime: '分段时间',
  segmentFreq: '分段频率',
  selecteTimeTip: '选择时间',
  powerTip: '定时开机和定时关机需要同时设置才生效',
  smartRule: '智能监管',
  timeingName: '定时点名',
  timeingHeart: '定时心率',
  time: '时间',
  mapFence: '电子围栏',
  inheritMapFence: '继承于上级机构的电子围栏',
  ownedMapFence: '创建的电子围栏',
  circle: '圆形',
  polygon: '多边形',
  district: '行政区',
  fenceName: '围栏名称',
  forbidType: '限制类型',
  timeOption: '时间策略',
  center: '中心点',
  radius: '半径(米)',
  newGroup: '新增监管规则',
  complete: '完成',
  templateName: '模板名称',
  templateDescription: '模板描述',
  addEntity: '添加实体',
  reason: '请假原因',
  preBack: '提前销假',
  backTip: '如果您想延长请假时间，请先销假再请假',
  bindEntity: '实体绑定',
  bindTip: '实体只能绑定所属机构拥有的设备',
  isBinding: '已绑定',
  entityInfo: '实体信息',
  noPic: '未上传照片',
  editEntity: '编辑实体',
  personalConfig: '个人配置',
  groupConfig: '分组配置',
  addTimeOption: '添加时间策略',
  personalFence: '个人围栏',
  noPersonalFence: '还没有创建个人围栏',
  drawFence: '绘制围栏',
  drawByWheel: '手动绘制',
  addPersonalFence: '添加个人围栏',
  selectDistrict: '选择地区',
  fenceCenter: '围栏中心点',
  editFence: '编辑围栏',
  deleteFence: '删除围栏',
  commitEdit: '提交修改',
  importEntitys: '实体导入',
  downloadTemplate: '模板下载',
  entityTemplate: '实体导入模板',
  selectedValue: '(值只能为{data}之一)',
  yzkj:'一直开机',
  mapType:'地图类型',
  indoorMap:'室内地图',
  outdoorMap:'室外地图',
  selectMapTypeTip:'请选择地图类型',
  scene:'场景',
  selectSceneTip:'请选择场景',
  fenceNumberTip:'禁入围栏数量支持绘制10个，禁出围栏数量支持绘制1个。',
  locationType:'定位方式',
  操作成功:'操作成功',
  heartbeatFreq:'心率/血压采集频率',
  oxygenFreq:'血氧采集频率',
}
export default supervise
